<template>
  <div class="bg-textura">
    <Head title="Fazer Login" />

    <jet-authentication-card>
      <template #logo>
        <jet-authentication-card-logo />
      </template>

      <div class="card-body">

        <jet-validation-errors class="mb-3" />

        <div v-if="status" class="alert alert-success mb-3 rounded-0" role="alert">
          {{ status }}
        </div>

        <p class="text-center" style="padding: 5px; color: #6667AB;">Faça login para iniciar sua sessão</p>

        <form @submit.prevent="submit">
          <div class="mb-3">
            <!-- <jet-label for="email" value="Email" /> -->
            <jet-input style="border-radius: 90px;  border-width: 2px;" id="email" type="email" v-model="form.email" required autofocus placeholder="Email"/>
          </div>

          <div class="mb-3">
            <!-- <jet-label for="password" value="Password" /> -->
            <jet-input style="border-radius: 90px; border-width: 2px;" id="password" type="password" v-model="form.password" required autocomplete="current-password" placeholder="Senha"/>
          </div>

          <div class="mb-3 d-flex justify-content-between">
            <div class="custom-control custom-checkbox " style="float: left">
              <jet-checkbox style="background-color: #DCDCDC;" id="remember_me" name="remember" v-model:checked="form.remember" />

              <label class="custom-control-label" for="remember_me">
                Lembrar acesso
              </label>
            </div>

            <jet-button style="border-radius: 90px; background-color: #6667AB; width: 200px; " class="ms-4" :class="{ 'text-white-50': form.processing }" :disabled="form.processing">
                <div v-show="form.processing" class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>

                Entrar
            </jet-button>
          </div>
        

        
        </form>
      </div>
      <div class="d-flex justify-content-between align-items-center px-5" style="background-color: #DCDCDC; height: 70px; width: 100%; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;">

    
            <div class="">
              <Link v-if="canResetPassword" :href="route('password.request')" class="text-muted me-3" >
                Esqueceu a senha?
              </Link>            
            </div>

            <div class="">
              <Link v-if="canResetPassword" href="#" class="text-muted me-3" data-bs-toggle="modal" data-bs-target="#exampleModal">
                Ainda não tem um registro?
              </Link>            
            </div>
        

      </div>
    </jet-authentication-card>
  </div>



  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Selecione a Prefeitura</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          
            
            <div class="row ">
              <div class="d-flex justify-content-center">
                <select class="form-control" name="prefeitura" id="prefeitura" v-model="prefeitura_set">
                  <option value="">Selecionar</option>
                  <option v-for="(prefeitura) in prefeituras" :value="prefeitura.url">{{prefeitura.descricao}}</option>     
                </select>
              </div>
            </div>
            
                   
        
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" style="border-radius: 90px;">Fechar</button>
          
          <a :href="prefeitura_url" v-if="prefeitura_set != ''">
                  <button type="button" class="btn btn-primary" style="border-radius: 90px; background-color: #6667AB; width: 150px; ">Cadastrar</button>
          </a>    

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { defineComponent } from 'vue'
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import axios from 'axios'

export default defineComponent({
  components: {
    Head,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
    Link,
  },

  props: {
    canResetPassword: Boolean,
    status: String
  },

  data() {
    return {
      prefeituras: [],
      prefeitura_set: '',
      prefeitura_url: '',

      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false
      })
    }
  },

  watch: {
    prefeitura_set: function (val) {
      this.prefeitura_url = '/lojistas/'+val+'/register'
    }
  },

  methods: {
    submit() {
      this.form
          .transform(data => ({
            ... data,
            remember: this.form.remember ? 'on' : ''
          }))
          .post(this.route('login'), {
            onFinish: () => this.form.reset('password'),
          })
    }
  },

  mounted(){
    axios.get('/api/login/prefeituras').then(response => {
      this.prefeituras = response.data   
    })
  }

  
})
</script>


<style scoped>
  .bg-textura{
    background-image: url('/assets/img/bg-login.png');
    background-size: cover;
    background-position: center center; 
    height: calc(100vh);
  }
</style>


